import BigNumber from 'bignumber.js'

function moveListIndex(i, isAsc = true) {
  return isAsc ? i - 1 : i + 1
}

export function formatQuoteList(list, isAsc = false) {
  let total = 0
  let result = []
  let i = isAsc ? list.length - 1 : 0
  let loop = list.length > 0
  const action = isAsc ? 'unshift' : 'push'
  while (loop) {
    const [price, size] = list[i]
    total = BigNumber(total).plus(size).toNumber()
    result[action]({
      price,
      size,
      total
    })
    i = moveListIndex(i, isAsc)
    loop = isAsc ? i >= 0 : i < list.length
  }
  return result
}

export function deltaUpdateQuoteList(list, deltaList, isAsk = true) {
  if (deltaList.length === 0) {
    return list
  }

  const result = []
  let total = 0
  let i = 0
  let j = 0
  let loop = list.length > 0 || deltaList.length > 0
  while (loop) {
    const { price: quotePrice, size: quoteSize } = list[i] || {}
    const [deltaQuotePrice, deltaQuoteSize] = deltaList[j] || []
    const hasDeltaQuote = j < deltaList.length
    if (quotePrice === deltaQuotePrice) {
      i += 1
      j += 1

      if (deltaQuoteSize !== 0) {
        total = BigNumber(total).plus(deltaQuoteSize).toNumber()
        result.push({
          price: quotePrice,
          size: deltaQuoteSize,
          total
        })
      }
    } else {
      const formula = isAsk
        ? quotePrice < deltaQuotePrice
        : quotePrice > deltaQuotePrice
      const useOriginData = formula || !hasDeltaQuote
      const price = useOriginData ? quotePrice : deltaQuotePrice
      const size = useOriginData ? quoteSize : deltaQuoteSize

      if (useOriginData) {
        i += 1
      } else {
        j += 1
      }
      total = BigNumber(total).plus(size).toNumber()
      result.push({
        price,
        size,
        total
      })
    }
    loop = i < list.length || j < deltaList.length
  }
  return result
}
